import { useAccountTypeNavigation } from "../../../hooks/useAccountTypeNavigation";
import {
  CASH_BOXES_BREADCRUMB,
  CASH_BOXES_PATH,
  CASH_BOXES_STRUCTURE_CRUMBS,
} from "./cash-boxes.constants";

export function useCashBoxesNavigation() {
  return useAccountTypeNavigation({
    path: CASH_BOXES_PATH,
    listBreadcrumb: CASH_BOXES_BREADCRUMB.list,
    structureCrumbs: CASH_BOXES_STRUCTURE_CRUMBS,
  });
}
